import { Lookup } from '../lookup.interface';
export const FinancialGoals: { [name: string]: Lookup } = {
  employment: { displayValue: 'Employment', code: 'employment' },
  pension: { displayValue: 'Pension', code: 'pension' },
  aish: { displayValue: 'AISH', code: 'aish' },
  provincialIncomeSupport: { displayValue: 'Provincial Income Support', code: 'provincialIncomeSupport' },
};
